export default __webpack_public_path__ + "static/media/mobi-info2.025c657c.webp";